import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { WORKSPACE_PLANS } from '../config/plans';
import './WorkspacePlans.css';

const descriptions = ['A place to start together.', 'More room for a growing team.', 'Space for every project.'];
const features = ['Tasks, boards and timelines', 'Comments and file attachments', 'Planning and dependencies', 'Project access controls', 'MCP for your AI agents'];

export function WorkspacePlans({ showActions = false }: { showActions?: boolean }) {
    return (
        <div className="workspace-plans">
            {WORKSPACE_PLANS.map((plan, index) => (
                <section className={`workspace-plan workspace-plan--${plan.key}`} key={plan.key} aria-label={`${plan.label} plan`}>
                    <span className="workspace-plan__marker" aria-hidden="true" />
                    <h3 className="workspace-plan__name">{plan.label}</h3>
                    <p className="workspace-plan__description">{descriptions[index]}</p>
                    <p className="workspace-plan__price"><span>$</span>{plan.monthly}<span> / month</span></p>
                    <p className="workspace-plan__unit">USD per workspace</p>
                    {showActions && <Link className="workspace-plan__action" to="/register" aria-label={`Start free with ${plan.label === 'Starter' ? 'Starter' : `a workspace, then upgrade to ${plan.label}`}`}>Start free</Link>}
                    <dl className="workspace-plan__limits">
                        <div><dt>Active projects</dt><dd>{plan.projects ?? 'Unlimited'}</dd></div>
                        <div><dt>People</dt><dd>{plan.people}</dd></div>
                    </dl>
                    <p className="workspace-plan__seat-note">Owner and guests included in the people limit.</p>
                    <div className="workspace-plan__features">
                        <h4>Included in every plan</h4>
                        <ul>{features.map(feature => <li key={feature}><Check size={17} aria-hidden="true" /><span>{feature}</span></li>)}</ul>
                    </div>
                    <p className="workspace-plan__footnote">{plan.monthly ? 'Upgrade from Billing when you’re ready.' : 'No payment details required.'}</p>
                </section>
            ))}
        </div>
    );
}
